import React from 'react';

import styles from './course-item.css';


class CourseItem extends React.Component {
    constructor() {
        super()
    }

    render() {

        const {
            fileSB3,
            data,
            num
        } = this.props
        return (
            <div
                className={styles.courseItem}
                onClick={() => { fileSB3(data) }}
            >
                <div className={styles.courseImg}>
                    <img src={data.imgurl} alt="" />
                </div>
                <div className={styles.courseTitle}
                    title={data.title}>
                    <p>
                        {`${num + 1}.${data.title}`}
                    </p>
                </div>
            </div>
        )
    }
}

export default CourseItem